import { Link } from "react-router-dom";

const LOGO_URL =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_4eeec132-0e4e-458b-8fe4-104767307b7b/artifacts/p51vzqkr_Logo.jpeg";

// variant: "image" (full colour logo on white) | "text" (typographic, for dark bg)
export function Logo({ variant = "image", className = "", to = "/" }) {
  if (variant === "text") {
    return (
      <Link to={to} data-testid="brand-logo" className={`flex items-center gap-2 ${className}`}>
        <span className="font-display text-2xl font-extrabold tracking-tight">
          <span className="text-[#E5B800]">ROD</span>
          <span className="text-white">AIR</span>
        </span>
      </Link>
    );
  }
  return (
    <Link to={to} data-testid="brand-logo" className={`flex items-center ${className}`}>
      <img src={LOGO_URL} alt="RODAIR Investments & Services Limited" className="h-10 w-auto sm:h-11 object-contain" />
    </Link>
  );
}
